import React from 'react';
import PropTypes from 'prop-types';

const Exclamation = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="exclamation" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,14.994079 C11.7976964,14.994079 11.6257408,14.9266455 11.4841283,14.7917764 C11.3425157,14.6569073 11.2582238,14.46135 11.23125,14.2050987 L10.4827302,6.33552623 L10.4625,6.13322359 C10.4625,5.71512939 10.6074821,5.38133338 10.8974506,5.13182555 C11.1874192,4.88231772 11.554932,4.75756568 12,4.75756568 C12.445068,4.75756568 12.8125808,4.88231772 13.1025494,5.13182555 C13.3925179,5.38133338 13.5375,5.71512939 13.5375,6.13322359 L13.5172698,6.35575649 L12.76875,14.2050987 C12.7417762,14.46135 12.6574843,14.6569073 12.5158717,14.7917764 C12.3742592,14.9266455 12.2023036,14.994079 12,14.994079 Z M12,19.2424343 C11.5684189,19.2424343 11.2110211,19.0974522 10.927796,18.8074837 C10.6445709,18.5175151 10.5029605,18.1567457 10.5029605,17.7251646 C10.5029605,17.2935835 10.6445709,16.932814 10.927796,16.6428455 C11.2110211,16.3528769 11.5684189,16.2078948 12,16.2078948 C12.4315811,16.2078948 12.7889789,16.3528769 13.072204,16.6428455 C13.3554291,16.932814 13.4970395,17.2935835 13.4970395,17.7251646 C13.4970395,18.1567457 13.3554291,18.5175151 13.072204,18.8074837 C12.7889789,19.0974522 12.4315811,19.2424343 12,19.2424343 Z" id="Combined-Shape" fill={color}></path>
      </g>
    </svg>
  );
}

Exclamation.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Exclamation.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Exclamation;



// WEBPACK FOOTER //
// ./src/components/Icons/Exclamation.jsx